
import { AUTH_URL } from "../../constants/urls";
import { apiSlice } from "./apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    verifyTcNo: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/TcNoVerification`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useVerifyTcNoMutation } = authApiSlice;
